import { render, staticRenderFns } from "./GrowthChangeRecord.vue?vue&type=template&id=4c037fd0&"
import script from "./GrowthChangeRecord.vue?vue&type=script&lang=js&"
export * from "./GrowthChangeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports